export const columns = [
  {
    accessorKey: "terminalId",
    header: "Terminal Id",
    type: "string",
    size: 130,
  },
  {
    accessorKey: "terminalName",
    header: "Name",
    type: "string",
    size: 130,
  },
  {
    accessorKey: "alias",
    header: "Alias",
    type: "string",
    size: 130,
  },
  {
    accessorKey: "terminalType",
    header: "Type",
    type: "string",
    size: 130,
  },
  {
    accessorKey: "description",
    header: "Description",
    type: "string",
    size: 130,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    size: 130,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    size: 130,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
